import type { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ARRIVAL_STATE } from '@/lib/arrival';
import { resolveMarketIndicator } from '@/lib/marketIndicator';
import { readRuntimeConfig } from '@/lib/runtimeConfig';
import { useSession } from '@/lib/session';
import {
  firstPermittedRoute,
  spaceOfPath,
  usableSpaces,
  type SpaceRouteTable,
} from '@/lib/spaceNavigation';
import { SPACES } from '@/lib/spaces';
import { SpaceSelector } from './SpaceSelector';

export interface SpaceBrandProps {
  // Handed down by routes.tsx, the only place allowed to hold paths.
  table: SpaceRouteTable;
}

// Derived on every render, never captured: a refetched /me can take a space away mid-session.
export function SpaceBrand({ table }: SpaceBrandProps): ReactElement {
  const session = useSession();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = spaceOfPath(pathname, table);
  // Off every space the pill reads as it always has. TODO: i18n
  const spaceLabel = SPACES.find((space) => space.id === current)?.label ?? 'Soporte';
  return (
    <SpaceSelector
      current={current}
      usable={usableSpaces(session, table)}
      indicator={resolveMarketIndicator(readRuntimeConfig(), spaceLabel)}
      spaceLabel={spaceLabel}
      onSelect={(spaceId) => {
        const home = firstPermittedRoute(spaceId, session, table);
        if (home !== null) void navigate(home.to, { state: ARRIVAL_STATE });
      }}
    />
  );
}
